import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiJson } from '@/lib/api';
import type { AuthLoginResponse, AuthMeResponse, StaffUser } from '@/types/auth';

const ME_KEY = ['auth', 'me'] as const;

export function useAuthMe() {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: () => apiJson<AuthMeResponse>('/api/auth/me'),
    staleTime: 60_000,
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { email: string; password: string }) =>
      apiJson<AuthLoginResponse>('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess: (data) => {
      if ('user' in data && data.user) {
        qc.setQueryData(ME_KEY, { user: data.user satisfies StaffUser });
      }
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiJson<{ ok: true }>('/api/auth/logout', { method: 'POST' }),
    onSettled: () => {
      qc.setQueryData(ME_KEY, { user: null });
      void qc.invalidateQueries({ queryKey: ME_KEY });
    },
  });
}
